// @vendors
const Immutable = require('immutable');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const initialState = Immutable.fromJS({
    namesHistory: [],
    isFetching: false,
});

const RAPortfoliosNameHistory = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_PORTFOLIOS_NAME_HISTORY_GET_DISPLAY_NAMES_SUCCESS:
            return state.merge({
                namesHistory: action.payload.data.filter(Boolean),
            });
        case actionTypes.RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_NAME_SUCCESS:
            const { portfolioName, namePosition } = action.payload;
            return state.setIn(['namesHistory', namePosition], portfolioName);
        case actionTypes.RA_OBJECTIVE_NAME_UPDATE_SUCCESS:
            const { data } = action.payload;
            return state.setIn(
                ['namesHistory', action.payload.namePosition],
                data.name,
            );
        default:
            return state;
    }
};

module.exports = RAPortfoliosNameHistory;
